




















import { Component, Vue } from 'vue-property-decorator';
import { ElForm } from 'element-ui/types/form.d';
import { authModule } from '@/store';
import Auth from '@/layouts/Auth.vue';
import * as amplitude from 'amplitude-js';

@Component({
  name: 'login-page',
  components: {
    Auth,
  },
})

export default class LoginPage extends Vue {
  $refs!: {
    form: ElForm
  }

  created() {
    amplitude.getInstance().logEvent('Страница входа');
  }

  submitting = false

  formData = {
    login: '',
    password: '',
  }

  rules = {
    login: [
      { required: true, message: 'Пожалуйста, введите свой логин', trigger: 'submit' },
    ],
    password: [
      { required: true, message: 'Пожалуйста, введите свой пароль', trigger: 'submit' },
    ],
  }

  submit() {
    this.$refs.form.validate((valid) => {
      if (valid) {
        this.submitting = true;
        authModule.tryToLogin(this.formData)
          .then(() => {
            this.$router.push({ name: 'clients' });
          })
          .then(() => {
            amplitude.getInstance().logEvent('Вошёл пользователь', { login: this.formData.login });
          })
          .catch((e) => {
            this.$message.error(e);
          })
          .finally(() => { this.submitting = false; });
      }
    });
  }
}
